/* =========================================================
   LABOOSH — CART DRAWER "YOU MAY ALSO LIKE"
   Loaded globally from layout/theme.liquid.

   The upsell cards are rendered SERVER-SIDE by
   snippets/laboosh-cart-upsell.liquid, so there is no fetching
   to do here. This file only provides the quick-add behaviour
   for those cards when they appear inside the cart drawer on a
   page where laboosh-product-card's own (snippet-scoped) script
   isn't present. It mirrors that handler and is guarded by
   window.__labooshQuickAddBound so the two never double-bind.
   ========================================================= */

(function () {
  'use strict';

  if (window.__labooshQuickAddBound) return;
  window.__labooshQuickAddBound = true;

  document.addEventListener('click', function (e) {
    // 1. Quick-add button click
    var openBtn = e.target.closest('[data-laboosh-quickadd-open]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = openBtn.closest('[data-laboosh-quickadd]');
      var directInput = wrap && wrap.querySelector('[data-direct-variant-id]');

      document
        .querySelectorAll('.laboosh-product-card__quickadd--open')
        .forEach(function (w) {
          if (w !== wrap) w.classList.remove('laboosh-product-card__quickadd--open');
        });

      if (directInput) {
        addToCart(directInput.getAttribute('value'), openBtn);
        return;
      }

      wrap.classList.toggle('laboosh-product-card__quickadd--open');
      return;
    }

    // 2. Size button click
    var sizeBtn = e.target.closest('.laboosh-product-card__quickadd-size');
    if (sizeBtn && !sizeBtn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      var wrap2 = sizeBtn.closest('[data-laboosh-quickadd]');
      addToCart(sizeBtn.getAttribute('data-variant-id'), sizeBtn, function () {
        if (wrap2) wrap2.classList.remove('laboosh-product-card__quickadd--open');
      });
      return;
    }

    // 3. Click outside — close overlays
    if (!e.target.closest('[data-laboosh-quickadd]')) {
      document
        .querySelectorAll('.laboosh-product-card__quickadd--open')
        .forEach(function (w) {
          w.classList.remove('laboosh-product-card__quickadd--open');
        });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document
        .querySelectorAll('.laboosh-product-card__quickadd--open')
        .forEach(function (w) {
          w.classList.remove('laboosh-product-card__quickadd--open');
        });
    }
  });

  function storefrontRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addToCart(variantId, btn, callback) {
    if (!variantId) return;
    var originalText = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = '…';
    }

    fetch(storefrontRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        return r.ok ? r.json() : r.json().then(function (er) { throw er; });
      })
      .then(function () {
        if (callback) callback();
        refreshAndOpenCart();
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
      })
      .catch(function (err) {
        console.warn('Quick add failed:', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
        alert((err && err.description) || 'Could not add to bag.');
      });
  }

  function refreshAndOpenCart() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) {
      window.location.href = storefrontRoot() + 'cart';
      return;
    }

    var sectionEl = cartDrawer.closest('.shopify-section');
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : 'header';

    fetch(storefrontRoot() + '?sections=' + encodeURIComponent(sectionId), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newDrawer = doc.querySelector('cart-drawer-component');
          var newCartIcon = doc.querySelector('cart-icon');
          if (newDrawer) {
            cartDrawer.replaceWith(newDrawer);
            cartDrawer = newDrawer;
          }
          var currentCartIcon = document.querySelector('cart-icon');
          if (newCartIcon && currentCartIcon && newCartIcon !== currentCartIcon) {
            currentCartIcon.replaceWith(newCartIcon);
          }
        }
        requestAnimationFrame(function () {
          var finalDrawer = document.querySelector('cart-drawer-component');
          if (finalDrawer) {
            finalDrawer.setAttribute('auto-open', '');
            if (typeof finalDrawer.open === 'function') {
              try { finalDrawer.open(); return; } catch (e) {}
            }
            if (typeof finalDrawer.showDialog === 'function') {
              try { finalDrawer.showDialog(); return; } catch (e) {}
            }
            var dialog = finalDrawer.querySelector('dialog');
            if (dialog && dialog.showModal) dialog.showModal();
          }
        });
      });
  }
})();


/* =========================================================
   LABOOSH — PRODUCT CARD TAP
   A single tap on a product card now goes straight to the product
   page (the mobile two-tap "reveal" behaviour was removed). The
   quick-add "+" handles its own taps (it stops the card link), and
   is shown on mobile via CSS.
   ========================================================= */


/* =========================================================
   LABOOSH — WISHLIST HEART ON CARDS: stop the card <a> from
   navigating when the Swym heart (inside the card link) is
   tapped. Swym still handles the add-to-wishlist itself.
   ========================================================= */
(function () {
  'use strict';
  if (window.__labooshWishlistGuardBound) return;
  window.__labooshWishlistGuardBound = true;

  document.addEventListener(
    'click',
    function (e) {
      var heart =
        e.target.closest('.swym-advanced-wishlist-collections-container') ||
        e.target.closest('.swym-advanced-wishlist-collections') ||
        e.target.closest('.swym-button');
      if (heart && heart.closest('.laboosh-product-card')) {
        // Cancel the parent product-link navigation; let Swym do its thing.
        e.preventDefault();
      }
    },
    true // capture, so it runs before the link's default action
  );
})();


/* =========================================================
   LABOOSH — WISHLIST COUNT BADGE (header)
   Uses Swym's official SDK (swat.fetch) for the REAL count, so
   there are no phantom/stale numbers. We render our own clean
   badge (.laboosh-wl-badge) and update it on Swym's add/remove
   events. Pattern per developers.getswym.com/docs/header-icon.
   ========================================================= */
(function () {
  'use strict';
  if (window.__labooshWlBadgeBound) return;
  window.__labooshWlBadgeBound = true;

  var lastCount = 0;

  function findIcon() {
    return document.querySelector(
      '#swym-advanced-header-icon, .swym-advanced-header-icon, a.swym-wishlist'
    );
  }

  // Re-attach + paint the badge with the last known count (no network).
  function paint() {
    var icon = findIcon();
    if (!icon) return;
    var host = icon.querySelector('.swym-header-icon-html') || icon;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var badge = icon.querySelector('.laboosh-wl-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'laboosh-wl-badge';
      badge.setAttribute('aria-hidden', 'true');
      host.appendChild(badge);
    }
    if (lastCount > 0) {
      var countText = lastCount > 99 ? '99+' : String(lastCount);
      if (badge.textContent !== countText) badge.textContent = countText;
      if (badge.style.display !== 'flex') badge.style.display = 'flex';
    } else {
      if (badge.style.display !== 'none') badge.style.display = 'none';
    }
  }

  function refresh(swat) {
    try {
      swat.fetch(function (products) {
        lastCount = products ? products.length : 0;
        paint();
      });
    } catch (e) { /* ignore */ }
  }

  function init(swat) {
    refresh(swat);
    if (swat.evtLayer && swat.evtLayer.addEventListener) {
      swat.evtLayer.addEventListener('sw:addedtowishlist', function () { refresh(swat); });
      swat.evtLayer.addEventListener('sw:removedfromwishlist', function () { refresh(swat); });
    }
    // Update on header replacement, never on a timer. Ignore the badge's own
    // DOM changes so this cannot create a repaint/observer loop.
    var framePending = false;
    var iconSelector = '#swym-advanced-header-icon, .swym-advanced-header-icon, a.swym-wishlist';
    function schedulePaint() {
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(function () {
        framePending = false;
        paint();
      });
    }
    new MutationObserver(function (records) {
      var iconAdded = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node instanceof Element &&
            (node.matches(iconSelector) || node.querySelector(iconSelector));
        });
      });
      if (iconAdded) schedulePaint();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', schedulePaint);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(init);
})();
(() => {
  if (window.__labooshCartLook) return;
  window.__labooshCartLook = true;
  let pending = false;
  function selectTab(root, name, focus) {
    root.querySelectorAll('[data-look-tab]').forEach(button => {
      const active = button.dataset.lookTab === name;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
      if (active && focus) button.focus();
    });
    root.querySelectorAll('[data-look-panel]').forEach(panel => { panel.hidden = panel.dataset.lookPanel !== name; });
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-look-tab]');
    if (tab) { event.preventDefault(); selectTab(tab.closest('[data-cart-look]'), tab.dataset.lookTab, false); return; }
    const move = event.target.closest('[data-look-move]');
    if (!move) return;
    event.preventDefault();
    const track = move.closest('[data-cart-look]').querySelector('[data-look-track]');
    if (!track) return;
    const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    track.scrollBy({left: Number(move.dataset.lookMove) * direction * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-look-tab]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const root = tab.closest('[data-cart-look]');
    const tabs = Array.from(root.querySelectorAll('[data-look-tab]'));
    const rtl = getComputedStyle(root).direction === 'rtl';
    const step = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + step + tabs.length) % tabs.length;
    selectTab(root, tabs[index].dataset.lookTab, true);
  });
  document.addEventListener('change', async event => {
    const select = event.target.closest('[data-cart-look-size]');
    if (!select || !select.value || pending) return;
    const root = select.closest('[data-cart-look]');
    const drawer = root.closest('cart-drawer-component');
    if (!drawer) return;
    const section = drawer.closest('.shopify-section');
    const sectionId = section ? section.id.replace('shopify-section-', '') : '';
    if (!sectionId) return;
    const base = root.dataset.root.endsWith('/') ? root.dataset.root : root.dataset.root + '/';
    const tab = root.querySelector('[data-look-tab][aria-selected="true"]').dataset.lookTab;
    const status = root.querySelector('[data-look-status]');
    const label = select.getAttribute('aria-label');
    const variant = select.value;
    const originalDisabled = Array.from(root.querySelectorAll('select')).map(el => [el, el.disabled]);
    const price = select.querySelector('option:checked')?.dataset.price;
    if (price) select.closest('article').querySelector('[data-look-price]').innerHTML = price;
    pending = true;
    root.setAttribute('aria-busy', 'true');
    originalDisabled.forEach(([el]) => { el.disabled = true; });
    status.textContent = root.dataset.adding;
    let added = false;
    try {
      const response = await fetch(base + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[{id:Number(variant),quantity:1}], sections:[sectionId], sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || root.dataset.error);
      added = true;
      let html = result.sections?.[sectionId];
      if (!html) {
        const rendered = await fetch(base + '?sections=' + encodeURIComponent(sectionId), {headers:{Accept:'application/json'}});
        if (rendered.ok) html = (await rendered.json())[sectionId];
      }
      if (!html) throw new Error(root.dataset.refreshError);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextDrawer = doc.querySelector('cart-drawer-component');
      if (!nextDrawer) throw new Error(root.dataset.refreshError);
      const wasOpen = drawer.querySelector('dialog')?.open;
      const scroll = drawer.querySelector('.cart-drawer__items')?.scrollTop || 0;
      drawer.replaceWith(nextDrawer);
      const icon = document.querySelector('cart-icon');
      const nextIcon = doc.querySelector('cart-icon');
      if (icon && nextIcon) icon.replaceWith(nextIcon);
      if (wasOpen) {
        if (typeof nextDrawer.open === 'function') nextDrawer.open();
        else if (typeof nextDrawer.showDialog === 'function') nextDrawer.showDialog();
        else nextDrawer.querySelector('dialog')?.showModal();
      }
      const nextRoot = nextDrawer.querySelector('[data-cart-look]');
      if (nextRoot) {
        if (nextRoot.querySelector('[data-look-tab="' + tab + '"]')) selectTab(nextRoot, tab, false);
        nextRoot.querySelector('[data-look-status]').textContent = nextRoot.dataset.added;
        const nextSelect = Array.from(nextRoot.querySelectorAll('select')).find(el => el.getAttribute('aria-label') === label);
        const focus = nextSelect || nextRoot.querySelector('[data-look-tab][aria-selected="true"]');
        if (wasOpen) focus?.focus({preventScroll:true});
      }
      const nextScroll = nextDrawer.querySelector('.cart-drawer__items');
      if (nextScroll) nextScroll.scrollTop = scroll;
    } catch (error) {
      status.textContent = added ? root.dataset.refreshError : error.message || root.dataset.error;
      if (added) {
        const checkout = drawer.querySelector('[name="checkout"]');
        if (checkout) checkout.disabled = true;
      }
    } finally {
      pending = false;
      root.removeAttribute('aria-busy');
      select.value = '';
      originalDisabled.forEach(([el, disabled]) => { el.disabled = disabled; });
    }
  });
})();
